import clsx from "clsx";

import { Button } from "components/button";

import styles from "./index.module.css";
import globalStyle from "index.module.css";

export type ErrorAction = {
  label: string;
  onClick: () => void;
  variant?:
    "primary" | "secondary" | "danger" | "dark-gradient" | "light-gradient" | "text" | "orange";
};

export type ErrorDisplayProps = {
  /** Error code to display (e.g., "404", "500") */
  errorCode?: string;
  /** Main title for the error */
  title: string;
  /** Descriptive text explaining the error */
  description: string;
  /** Array of action buttons to display */
  actions?: ErrorAction[];
  /** Whether to show the full-height container with gradient background */
  fullHeight?: boolean;
  /** Additional CSS class name */
  className?: string;
};

export function ErrorDisplay({
  errorCode,
  title,
  description,
  actions = [],
  fullHeight = true,
  className,
}: ErrorDisplayProps) {
  return (
    <div className={clsx(globalStyle.container, { [styles.fullHeight]: fullHeight }, className)}>
      <div className={styles.card}>
        {errorCode && <h1 className={styles.errorCode}>{errorCode}</h1>}
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        {actions.length > 0 && (
          <div className={styles.actions}>
            {actions.map((action, index) => (
              <Button
                className={styles.button}
                key={`${action.label}-${index}`}
                onClick={action.onClick}
                variant={action.variant ?? "orange"}
              >
                {action.label}
              </Button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
